import { ArrowDown } from '@zappyrent/hundop';
import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { IUser } from '../../../shared/ts/user';
import { CollapsibleContent, CollapsibleControl } from '../../UI/Collapsible';

export const StyledListItem = styled.li`
  padding: ${rem('24px')};
  border-radius: ${'16px'};
  box-shadow: ${({ theme }) =>
    `0 0 ${rem('8px')} ${rgba(theme.colors.cross.silverFox, 0.5)}`};

  &:not(:last-child) {
    margin-bottom: ${rem('24px')};
  }

  display: grid;
  grid-template-columns: 1fr max-content;
  gap: ${rem('24px')};
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTitle = styled.h2`
  margin: 0;
  font-size: ${rem('16px')};
  max-width: ${rem('500px')};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledDeletedTitle = styled.h2`
  margin: 0;
  padding: ${rem('1px')} ${rem('8px')};
  font-size: ${rem('10px')};
  border: ${rem('1px')} solid;
  border-radius: ${rem('5px')};
  margin-left: ${rem('10px')};
  color: ${({ theme }) => theme.colors.cross.red};
  border-color: ${({ theme }) => theme.colors.cross.red};
`;

export const StyledDescriptionList = styled.dl`
  margin: 0;
  margin-top: ${rem('4px')};

  & dt {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  & dd {
    font-size: ${rem('12px')};
    font-weight: 700;
    margin: 0;
    color: ${({ theme }) => theme.colors};
  }
`;

export const StyledCollapsibleControlArrow = styled(ArrowDown)`
  width: ${rem('10px')};
  height: auto;
  transition: all 0.3s ease-in-out;
`;

export const StyledCollapsibleControlText = styled.span`
  display: inline-flex;
  border-radius: ${'4px'};
  padding: ${rem('8px')} ${rem('14px')};
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  font-size: ${rem('13px')};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.cross.grayson};
`;

export const StyledCollapsibleControl = styled(CollapsibleControl)`
  padding: ${rem('8px')};
  padding-right: ${rem('16px')};
  border-radius: ${'8px'};
  border: ${({ theme }) =>
    `${rem('1px')} solid ${theme.colors.cross.silverFox}`};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${rem('16px')};
  background-color: transparent;
  appearance: none;
  cursor: pointer;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    grid-column: span 2;
  }

  &[aria-expanded='true'] ${StyledCollapsibleControlArrow} {
    transform: rotate(180deg);
  }
`;

export const StyledCollapsibleContent = styled(CollapsibleContent)`
  grid-column: span 2;
`;

export const StyledBookginDetailsTabList = styled.ul`
  position: relative;
  list-style: none;
  padding: 0;
  margin-bottom: ${rem('16px')};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    display: block;
    border-top: ${rem('1px')} solid
      ${({ theme }) => theme.colors.cross.silverFox};
  }
`;

export const StyledBookginDetailsTabItem = styled.li<{ user: IUser['type'] }>`
  position: relative;
  color: ${({ theme, user }) => theme.colors[user!].main};
  border-top: ${rem('1px')} solid
    ${({ theme, user }) => theme.colors[user!].main};
  font-weight: 600;
  font-size: ${rem('14px')};
  padding: ${rem('8px')} 0;
  width: min-content;
`;
